module.exports = __webpack_public_path__ + "img/favorite-chart.9d98c8cb.svg";